// extracted by mini-css-extract-plugin
module.exports = {"baseSectionTitle":"BaseSectionTitle_baseSectionTitle_taf8_","isStyleTheme":"BaseSectionTitle_isStyleTheme_fcne0"};